/**
 * @generated SignedSource<<86a86feeda4d64d0f43e1e12dc28fed5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SellerTryOnState = "ACTIVE" | "NOT_ACTIVE";
export type vtoEditorTryOnCustomerQuery$variables = {
  providerId: number;
  typeId: number;
};
export type vtoEditorTryOnCustomerQuery$data = {
  readonly tryOnCustomer: {
    readonly id: string;
    readonly providerID: number;
    readonly sellerID: number;
    readonly settings: string | null;
    readonly typeID: number;
    readonly vtoState: SellerTryOnState;
  } | null;
};
export type vtoEditorTryOnCustomerQuery = {
  response: vtoEditorTryOnCustomerQuery$data;
  variables: vtoEditorTryOnCustomerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "providerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "typeId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "providerID",
        "variableName": "providerId"
      },
      {
        "kind": "Variable",
        "name": "typeID",
        "variableName": "typeId"
      }
    ],
    "concreteType": "SellerTryOn",
    "kind": "LinkedField",
    "name": "tryOnCustomer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sellerID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "providerID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "typeID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "settings",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vtoState",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "vtoEditorTryOnCustomerQuery",
    "selections": (v2/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "vtoEditorTryOnCustomerQuery",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "cacheID": "c238dc17da8652005b094ca1b931b72d",
    "id": null,
    "metadata": {},
    "name": "vtoEditorTryOnCustomerQuery",
    "operationKind": "query",
    "text": "query vtoEditorTryOnCustomerQuery(\n  $typeId: Int!\n  $providerId: Long!\n) {\n  tryOnCustomer(typeID: $typeId, providerID: $providerId) {\n    id\n    sellerID\n    providerID\n    typeID\n    settings\n    vtoState\n  }\n}\n"
  }
};
})();

(node as any).hash = "05ad8e36d1a3774d04cf7de9823a19cf";

export default node;
